import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ConstructionIcon from '@mui/icons-material/Construction';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import SavingsIcon from '@mui/icons-material/Savings';
import Polaroid from './img/polaroid.png';
import EthereumIcon from '../../../components/EthereumIcon';
import './style.css'
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom';
import { PATH_BOARD, PATH_MARKETPLACE } from '../../config';
import SolidityIcon from '../../../components/SolidityIcon';
import IPFSIcon from '../../../components/IPFSIcon';
import AddIcon from '@mui/icons-material/Add';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import { useMediaQuery } from '@mui/material';
import VantaBg from '../../../components/VantaBg';
import { channelUrl } from '../../../util/telegram';
import TelegramIcon from '@mui/icons-material/Telegram';
import FugIcon from './img/fug.jpg'
import BioIcon from './img/bioxtc.png'
import SweetDIcon from './img/sweetd.jpg'
import BurningIcon from './img/burning.png'

const Home = () => {

    const isDesktop = useMediaQuery( theme => theme.breakpoints.up( 'sm' ) );

    return (
        <section className="coe__home">

            <VantaBg className="coe__home__hero">
                {
                    isDesktop ?
                        <Container className="coe__home__hero__content">
                            <Typography variant="bigboy" component="h2">Chain of Events</Typography>
                        </Container> :
                        null
                }
            </VantaBg> 

            <Container sx={{ mb: 6, mt: 4 }}>
                <Grid container alignItems="center" spacing={ isDesktop ? 16 : 3 } sx={{ mb: isDesktop ? 0 : 3 }}>
                    {
                        isDesktop ?
                            <Grid item md={ 4 }>
                                <img src={ Polaroid } alt="something unspeakable" className="coe__home__polaroid" width="394" height="465" />
                            </Grid> :
                            null
                    }
                    <Grid item md={ 8 } xs={ 12 }>
                        <Typography variant="bigboy" component="h2" sx={{ mb: 4 }}>Hold them accountable.</Typography>
                        <Typography>
                            Uncover the truth with our evidence board NFT application. Based on the Ethereum Blockchain, this cutting-edge technology 
                            allows you to securely store and share critical information, exposing corruption and holding those in power accountable. Join the movement 
                            for truth and take control of your own investigation with Chain of Events.
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={ !isDesktop ? 8 : 3 }>
                    <Grid item md={ 4 } xs={ 12 }>
                        <Paper sx={{ height: '100%', padding: 3, pb: 0 }} elevation={ 6 }>
                            <Stack spacing={ 3 } alignItems="center">
                                <ConstructionIcon color="primary" sx={{ fontSize: 80 }} />
                                <Typography variant="h1" component="h3">Build it.</Typography>
                                <Typography textAlign="center">
                                    Build your evidence board with our cutting-edge application based on the Ethereum blockchain. Store and secure your data with 
                                    the power of decentralized technology, and share it with the world to uncover hidden conspiracies and bring transparency to the forefront.
                                </Typography>
                                <Button variant="contained" to={ PATH_BOARD } component={ Link }>Get Started</Button>
                            </Stack>
                        </Paper>
                    </Grid>
                    <Grid item md={ 4 } xs={ 12 }>
                        <Paper sx={{ height: '100%', padding: 3, pb: 0 }} elevation={ 6 }>
                            <Stack spacing={ 3 } alignItems="center">
                                <SavingsIcon color="primary" sx={{ fontSize: 80 }} />
                                <Typography variant="h1" component="h3">Mint it.</Typography>
                                <Typography textAlign="center">
                                    Mint your own unique piece of digital evidence and add it to the decentralized network of truth-seekers with our NFT application. With our platform, 
                                    you can create and sell your evidence as an NFT, allowing you to monetize your research and bring credibility to your findings.
                                </Typography>
                            </Stack>
                        </Paper>
                    </Grid>
                    <Grid item md={ 4 } xs={ 12 }>
                        <Paper sx={{ height: '100%', padding: 3, pb: 0 }} elevation={ 6 }>
                            <Stack spacing={ 3 } alignItems="center">
                                <CurrencyExchangeIcon color="primary" sx={{ fontSize: 80 }} />
                                <Typography variant="h1" component="h3">Trade It.</Typography>
                                <Typography textAlign="center">
                                    Join the community of analysts and trade valuable pieces of evidence on the decentralized market. Our NFT application allows you to buy and 
                                    sell NFTs representing proof, connecting you with like-minded individuals and empowering you to expose the truth together.
                                </Typography>
                                <Button variant="contained" to={ PATH_MARKETPLACE } component={ Link }>Visit the Marketplace</Button>
                            </Stack>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>

            <section className="coe__home__market">

                <Container className="coe__home__market__content" sx={{ pt: 6, pb: 6 }}>
                    <div className="coe__home__market__content__child">
                    
                        <Typography variant="bigboy">Combat memory holes</Typography>
                
                        <Stack 
                            alignItems="center"
                            direction="row"  
                            divider={ <AddIcon sx={{ fontSize: isDesktop ? 80 : 30 }} /> }
                            justifyContent="space-between" 
                            sx={{ mb: 6, mt: 6 }}>
                            <EthereumIcon className="coe__home__market__content__logo" />
                            <IPFSIcon className="coe__home__market__content__logo" />
                            <SolidityIcon className="coe__home__market__content__logo" />
                        </Stack>
                
                        <Typography sx={{ mb: 2 }}>
                            A decentralized network ensures that your evidence is stored in multiple locations, reducing the risk of losing information when the narrative changes. 
                            Web archives, such as the Wayback Machine, provide a secure repository of websites and web pages that have been archived over time, 
                            ensuring that data is preserved for future generations to access.
                        </Typography>
                        <Typography>
                            By combining these two approaches, you can ensure that the evidence will persist -- immutable -- forever.
                        </Typography>
                    </div>
                </Container>
                
            </section>

            <section className="coe__home__team">
                <Container className="coe__home__team__content" sx={{ pt: 6, pb: 6 }}>
                    <Stack>
                        <Typography variant="h1" component="h2">Our Team</Typography>
                        
                        <List sx={{ columns: isDesktop ? 2 : 1 }}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar src={ FugIcon } />
                                </ListItemAvatar>
                                <ListItemText 
                                    primary="PapaFugatu" 
                                    secondary="Lead Developer & Co-Founder"/>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar src={ BioIcon } />
                                </ListItemAvatar>
                                <ListItemText 
                                    primary="BioXTC" 
                                    secondary="Lead Tester & Co-Founder"/>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar src={ SweetDIcon } />
                                </ListItemAvatar>
                                <ListItemText 
                                    primary="SweetD" 
                                    secondary="Tester"/>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar src={ BurningIcon } />
                                </ListItemAvatar>
                                <ListItemText 
                                    primary="SmellsLikeBurning" 
                                    secondary="DevOps"/>
                            </ListItem>
                        </List>
                            
                        
                    </Stack>
                </Container>
            </section>

            <Container className="coe__home__community" sx={{ pt: 6, pb: 6 }} >

                <Stack alignItems="center">
                    <Typography variant="h1" component="h2">Want to Get Involved?</Typography>

                    <Button variant="contained" href={ channelUrl } startIcon={ <TelegramIcon /> } target="_blank">
                        Join our Telegram
                    </Button>
                </Stack>

            </Container>

            

        </section>
        
    )

}

export default Home;